var metaCustomJs = document.querySelector('meta[name="custom-js"]');
let isLeaflet    = false;

if (metaCustomJs != null) {
  if (metaCustomJs.getAttribute('custom-js') == 'true') {
    isLeaflet = true;
  }
}

const Leaflet = (
  await import(`${isLeaflet ? `https://ga.jspm.io/npm:leaflet@1.9.4/dist/leaflet-src.js` : `./leaflet`}`)
).default

$(document).ready(function() {
  // Init modal
  const modalLocation = document.getElementById('modal-nearby-store');

  if (modalLocation){
    // Map init
    const locDetail = new bootstrap.Modal(modalLocation);

    var latLong        = [4.2105, 101.9758]
    var list_merchants = document.querySelectorAll('.list-merchants')
    var targetMerchantId = document.querySelector('.id-selected-merchant').dataset['targetMerchantId']

    if (list_merchants.length >= 1) {
      var targetMerchant = Array.from(list_merchants).find(merchant => merchant.dataset.merchantId === targetMerchantId);
      if (targetMerchant) {
        var dataset = targetMerchant.dataset;
        latLong = [parseFloat(dataset.merchantLatitude), parseFloat(dataset.merchantLongitude)];
      }
    }

    let mapOptions = {
      center: latLong,
      zoom: 15,
    }

    const mapEl = document.querySelector('#map')
    if (!mapEl){
      return null
    }

    let map = Leaflet.map('map', mapOptions)

    let layer = new Leaflet.TileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png')

    map.addLayer(layer)
    map.zoomControl.remove()

    // Marker init
    let iconOptions = {
      iconUrl: '/assets/liquids/assets/icons/pin.svg',
      iconSize: [42, 42],
      iconAnchor: [16, 32],
    }

    // Function to slightly offset markers with the same coordinates
    function offsetLatLng(latlng, index) {
      const offset = 0.00006 * index;
      return [
        latlng[0] + offset,
        latlng[1] + offset
      ];
    }

    let existingMarkers = {};

    list_merchants.forEach(function(tabLink) {
      var dataset   = tabLink.dataset;
      var latitude  = parseFloat(dataset['merchantLatitude']);
      var longitude = parseFloat(dataset['merchantLongitude']);
      var name      = dataset['merchantName'];
      let latlng    = [latitude, longitude];
      let latlngKey = latlng.toString();

      if (existingMarkers[latlngKey]) {
        latlng = offsetLatLng(latlng, existingMarkers[latlngKey]);
        existingMarkers[latlngKey]++;
      } else {
        existingMarkers[latlngKey] = 1;
      }

      let marker = Leaflet.marker(latlng, { icon: Leaflet.icon(iconOptions), title: name }).addTo(map);

      marker.on('click', function () {
        $('#merchant-name').text(name)
        $('#merchant-address').text(dataset['merchantAddress'])
        $('#popup-map-direction').attr('data-merchant-id', dataset['merchantId'])
        $('#merchant-thumbnail').attr('src', dataset['merchantImage'])

        if (dataset['merchantOpen']) {
          $('#opening-hours').addClass('badge-success');
          $('#opening-hours').removeClass('badge-danger');
          $('#opening-hours').text('Open');
        } else {
          $('#opening-hours').addClass('badge-danger');
          $('#opening-hours').removeClass('badge-success');
          $('#opening-hours').text('Close');
        }


        locDetail.show()
      })
    })
  }
})
